<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r7cCEu/tc-custom/9781466852587.jpg?1728726194059" alt="This image is the cover for the book Make You Mine, Nine Circles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Make You Mine, Nine Circles
      </h1>
      <p class="bookDescription body article font2">
        <b>An icy bodyguard helps her billionaire boss entrap an enemy in this “outstanding, unabashedly sexy” erotic, suspenseful romance (<i>Publishers Weekly</i>).</b><br/><br/>International playboy Alex St. James always plays to win. Whether it’s betting on a high-stakes card game—or bedding a high-class socialite—the gorgeous world-class gambler knows how to beat the odds using his brains, his body, and a whole lot of charm. But there’s one woman who’s immune to Alex’s bag of tricks—which makes her the perfect challenge . . . and the ultimate prize.<br/><br/>Once a special operative in her native Russia, Katya Ivanov knows what kind of man Alex is. As his personal bodyguard, she’s seen him seduce the richest women, place the riskiest bets, and break the hardest players. But to even a score from her past, she’s willing to take a gamble on her reckless boss. Even if she has to pretend to be his lover. Even if he drives her mad with desire. And then she never wants this dangerous game to end . . .<br/><br/><b>Praise for <i>Make You Mine</i></b><br/><br/>“Powerfully suspenseful and, above all, sensual and meaningful . . . not to be missed.” —<i>RT Book Reviews </i>(Top Pick!)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jackie Ashenden
      </h2>
      
      <p class="authorDescription body article"><P>Jackie Ashenden lives in Auckland, New Zealand with her husband, the inimitable Dr Jax, two kids and two cats. When she's not torturing alpha males and their stroppy heroines, she can be found drinking chocolate martinis, reading anything she can lay her hands on, posting random crap on her blog, or being forced to go mountain biking with her husband. <br>Jackie writes dark, sexy contemporary romance for St Martin's Press, including the first novel in the <I>Nine Circles </I>series, <I>Mine to Take</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5961c7fe